// app/src/features/branch/BranchControls.jsx
import React from "react";
import { BranchEngineConfirmModal } from "../../components/BranchEngineConfirmModal.jsx";

/**
 * The branch bucket's confirm surface: the deep-engine confirm modal `useBranchForecast` awaits
 * (through `useBranchWiring`'s gate) before a branch inherits a deep-lane engine the picker did
 * not select. Rendered beside `AppFrame` (not a frame slot), next to the delete-forecast confirm
 * as the inline JSX was, for the phone and the desktop layouts alike; reads `branchEngineConfirm`
 * and `settleBranchEngineConfirm` (the wiring's) from the frame context. The modal keeps its prop
 * literals built here (`components/*` is PKG-06's).
 */
export default function BranchControls({ ctx }) {
  const { branchEngineConfirm, settleBranchEngineConfirm } = ctx;
  return (
    <>
      {/* Shown when a branch would run on a deep-lane engine inherited from its root that the
         picker did not select; either button (or the backdrop) settles the awaited answer. */}
      {branchEngineConfirm && (
        <BranchEngineConfirmModal
          inheritedEngine={branchEngineConfirm.inheritedEngine}
          pickerEngine={branchEngineConfirm.pickerEngine}
          onConfirm={() => settleBranchEngineConfirm(true)}
          onCancel={() => settleBranchEngineConfirm(false)}
        />
      )}
    </>
  );
}
